import { createSlice } from "@reduxjs/toolkit";
import { defaultAddReducer, defaultSetReducer, defaultUpdateReducer, defaultRemoveReducer } from "./defaultReducer";

const initialState = {
  list: [],
};

const slice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    // Give case reducers meaningful past-tense "event"-style names
    setRolesReducer: defaultSetReducer,
    updateRolReducer: defaultUpdateReducer,
    addRolReducer: defaultAddReducer,
    removeRolReducer: defaultRemoveReducer,
  },
});

// `createSlice` automatically generated action creators with these names.
// export them as named exports from this "slice" file
export const { setRolesReducer, updateRolReducer, addRolReducer, removeRolReducer } = slice.actions;

// Export the slice reducer as the default export
export default slice.reducer;
